import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { focusSubLinks } from '../../data/focusSubLinks';

function FocusDropdown({ onNavigate }) {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen((v) => !v), []);

  const handleClick = useCallback(() => {
    setOpen(false);
    if (onNavigate) onNavigate();
  }, [onNavigate]);

  return (
    <li className="nav-dropdown-wrap">
      <button className="nav-dropdown-trigger" onClick={toggle}>
        Focus Area
        <ChevronIcon open={open} />
      </button>
      {open && (
        <ul className="nav-dropdown-menu">
          {focusSubLinks.map((sub) => (
            <li key={sub.label}>
              <Link to={sub.to} onClick={handleClick}>{sub.label}</Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
}

function ChevronIcon({ open }) {
  return (
    <svg
      className={`chevron ${open ? 'rotated' : ''}`}
      viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" width="14" height="14"
    >
      <polyline points="6,9 12,15 18,9" />
    </svg>
  );
}

export default FocusDropdown;
